export const SOCIAL_SETTINGS = {
    IOS_APP_ID: '380932800',
    ANDROID_APP_ID: 'com.zoopla.activity',
    TWITTER_ACCOUNT_ID: '19903963',
    FB_ADMINS: '100003926523449',
    IPHONE_BASE_URL: 'zoopla://',
    TWITTER_PLAY_BASE_URL: 'android-app://com.zoopla.activity/zoopla',
    TWITTER_ANDROID_APP_NAME: 'zoopla',
    TWITTER_IOS_APP_NAME: 'zoopla'
};
